import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

const defaultApiRoot = process.env.VUE_APP_ROOT_API || "/api";
/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
    init() {
        // we define the base URL for authentication
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = defaultApiRoot;
        Vue.axios.defaults.headers.get["Accept"] = "application/json";
        this.setHeader();
    },

    /**
     * Set the default HTTP request headers
     */
    setHeader() {
        const token = localStorage.getItem("id_token");
        if (token) {
            Vue.axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
        }
    },

    query(resource, params) {
        return Vue.axios.get(resource, params);
    },

    /**
     * Send the GET HTTP request
     * @param resource
     * @param slug
     * @returns {*}
     */
    get(resource) {
        this.setHeader();
        return Vue.axios.get(`${resource}`);
    },

    normalPost(resource) {
        return Vue.axios.post(`${resource}`);
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },

    commit(resource, id) {
        this.setHeader();
        Vue.axios.defaults.headers.post["Content-Type"] =
            "application/json-patch+json";
        return Vue.axios.post(`${resource}`, id);
    },

    download(resource, slug) {
        this.setHeader();
        return Vue.axios.get(`${resource}/${slug}`);
    },

    downloadWithParam(resource, slug, param) {
        this.setHeader();
        let config = {
            // example url
            url: `${resource}/${slug}?fileName=${param}`,
            method: "GET",
            responseType: "blob",
        };
        return Vue.axios(config);
    },

    upload(resource, file) {
        this.setHeader();
        Vue.axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        return Vue.axios.post(`${resource}`, file);
    },

    postFormData(resource, formData) {
        this.setHeader();
        Vue.axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        return Vue.axios.post(`${resource}`, formData);
    },

    uploadModifica(resource, file) {
        this.setHeader();
        Vue.axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
        return Vue.axios.put(`${resource}`, file);
    },

    customGet(resource, slug) {
        this.setHeader();
        let config = {
            // example url
            url: `${resource}${slug}`,
            method: "GET",
            responseType: "blob",
        };
        return Vue.axios(config);
    },

    generate(resource) {
        this.setHeader();
        let config = {
            // example url
            url: `${resource}`,
            method: "GET",
            responseType: "blob",
        };
        return Vue.axios(config);
    },

    /**
     * Download file with proper headers
     * @param resource
     * @returns {*}
     */
    downloadFile(resource) {
        this.setHeader();
        let config = {
            url: `${resource}`,
            method: "GET",
            responseType: "blob",
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream'
            }
        };
        return Vue.axios(config);
    },

    /**
     * Send the UPDATE HTTP request
     * @param resource
     * @param slug
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    /**
     * Send the PUT HTTP request
     * @param resource
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    /**
     * Send the DELETE HTTP request
     * @param resource
     * @returns {*}
     */
    delete(resource, id) {
        return Vue.axios.delete(`${resource}/${id}`);
    },

    /**
     * Send the DELETE HTTP request without ID
     * @param resource
     * @returns {*}
     */
    deleteResource(resource) {
        return Vue.axios.delete(`${resource}`);
    },
};

export default ApiService;
